import {Injectable, Injector} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {BaseService} from '@twpub/core/services';
import {environment} from '../../../../environments/environment';

export interface License {
  name: string;
  version?: string;
  licenses?: string | string[];
  repository?: string;
  homepage?: string;
  licenseText?: string;
  publisher?: string;
  email?: string;
  url?: string;
}

export interface VersionInfo {
  version: string;
  frontendLicenses: License[];
  backendLicenses: License[];
}

@Injectable({
  providedIn: 'root'
})
export class AboutService extends BaseService {
  constructor(injector: Injector) {
    super(injector)
  }

  getVersionInfo(): Observable<VersionInfo> {
    return forkJoin({
      version: this.getAppVersion(),
      frontendLicenses: this.getFrontendLicenses(),
      backendLicenses: this.getBackendLicenses()
    });
  }

  private getAppVersion(): Observable<string> {
    return new Observable<string>(observer => {
      observer.next('v' + environment.appVersion + '  (build ' + environment.buildNumber + ')');
      observer.complete();
    });
  }

  private getFrontendLicenses(): Observable<License[]> {
    const langPrefix = environment.production ? '/en' : '';
    return this.http.get<License[]>(langPrefix + '/assets/licenses/frontend-licenses.json');
  }

  private getBackendLicenses(): Observable<License[]> {
    return this.http.get<License[]>(this.url('/licenses'));
  }
}
